import ConciliationAdjustmentAmount from '../ui/ConciliationAdjustmentAmount'
import { getConciliationAdjustmentDisplay } from '../../utils/conciliationAdjustmentDisplay'
import { getConciliationBalanceAmount } from '../../utils/conciliationBalanceRows'
import { getConciliationAccountDisplayNumber } from '../../utils/conciliationAccountDisplay'
import { useState, useEffect, useContext, useMemo, useCallback, useRef, startTransition } from 'react'
import GlobalContext from '../../../context/global-context'
//assets
import isologo_SII from '../../../assets/isologo_SII.png'
import iconVinculos from '../../../assets/iconosCardInformes/informe_9.png'
import iconPrevired from '../../../assets/iconosBancos/previred-logo.png'
import { VinculacionIcon } from '../views/dashboard/Administracion/Vinculaciones/IconosPlantilla'
import {
  getMovementAppliedAmount,
  getMovementRelationDate,
  isSameConciliationMovement,
  isBankConciliationMovement,
  isVinculacionRow
} from '../views/dashboard/Administracion/bancos/modalDialogCreate/respaldo.utils'
//api
import { OrganizationAPI } from '../../../api/organization.api'
import { BankAPI } from '../../../api/bancos.api'
import { BusinessAPI } from '../../../api/business.api'
import translations from '../ui/traslation/traslationAdministracion.json'
import { useSummaryMovementsOverrides } from '../../../pages/useAdministracion.hooks'
// components
import { Button, ForeignAmountDetail } from '../ui/index'
import { formatDate, formatCurrency } from '../../utils/formatter'
import { bankIcons, getFolioCreditoLabel, isF29Movement } from '../../modules/views/dashboard/Administracion/bancos/data'
import imgDefaultBank from '../../../assets/iconos/iconCasa.png'
// material
import BankLinkageProgress from '../views/dashboard/Administracion/bancos/modalDialogCreate/BankLinkageProgress'
import FiltrosLista from '../views/dashboard/Administracion/bancos/modalDialogCreate/FiltrosLista'
import LoaderMain from '../../../assets/svgIcons/loaderMain.json'
import Lottie from 'lottie-react'
import { Box } from '@mui/material'
import ResizableModal from '../ui/ResizableModal'
import ConfirmConciliationModal from '../ui/ConfirmConciliationModal'
import { normalizeConciliationPayload } from '../../utils/normalizeConciliationLinkage'
import { applyConciliationAdjustment } from '../../utils/conciliationAdjustment'
import { buildBankConciliationPayload } from './bankConciliationPayload'
import AssignedAmountInput from './AssignedAmountInput'
import { getVinculacionAvailableAmount } from '../../utils/vinculacionAmounts'
import { allocateConciliationMovements } from '../../utils/conciliationAllocation'
import { preferAdjustmentConciliationRows } from '../../utils/conciliationRows'

const ModalDialogMotionEditForm = ({ open, setOpen, libroId, setSwitchGetData }) => {
  const getLinkageRowId = item => item?.id ?? item?.idPrincipal
  const [data, setData] = useState({})
  //const [dataCustom] = useState({ typeMovement: '1' })
  const [, setDataCuentas] = useState([])
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const bancoAPI = new BankAPI()
  const businessAPI = new BusinessAPI()
  const [, setReload] = useState(false)
  const [reloadData, setReloadData] = useState(false)
  const [loading, setLoading] = useState(false)
  const [creationStatus, setCreationStatus] = useState(null)
  const [creationError, setCreationError] = useState('')
  const creatingLinkage = Boolean(creationStatus)
  const submitRef = useRef(null)
  const handleConciliateCreated = useCallback(rows => submitRef.current(rows), [])
  const handleCreationCompleted = useCallback(() => {
    setSwitchGetData(true)
    setOpen(false)
  }, [setSwitchGetData, setOpen])
  const setMovementOverride = useSummaryMovementsOverrides(state => state.setOverride)
  const [initialSelectedIds, setInitialSelectedIds] = useState([]) 
  const [currentSelectedIds, setCurrentSelectedIds] = useState([])
  const [selectedRowsData, setSelectedRowsData] = useState([])
  const handleCurrentData = useCallback(rows => {
    setSelectedRowsData(preferAdjustmentConciliationRows(rows))
  }, [])
  const [editedAmounts, setEditedAmounts] = useState({})
  const editedAmountsRef = useRef({})
  useEffect(() => {
    editedAmountsRef.current = {}
    setEditedAmounts({})
  }, [open, libroId, currentBusiness?.id])
  const getAdjustmentMovement = item => (data?.linkage ?? []).find(linked =>
    isSameConciliationMovement(item, linked) && getConciliationAdjustmentDisplay(linked)) ?? item
  const getBaselineAmount = item => getConciliationAdjustmentDisplay(getAdjustmentMovement(item))
    ? getConciliationBalanceAmount(getAdjustmentMovement(item), data?.linkage ?? [])
    : (data?.linkage ?? []).some(linked =>
    String(linked.idPrincipal ?? linked.id) === String(item.idPrincipal ?? item.id))
    ? getMovementAppliedAmount(item, data?.linkage)
    : getVinculacionAvailableAmount(item)
  const getSelectedAmount = item => editedAmounts[getLinkageRowId(item)] ?? getBaselineAmount(item)
  const handleAmountChange = (item, value) => {
    const amount = Number(value.replace(/[^\d]/g, '') || 0)
    if (amount > getVinculacionAvailableAmount(item)) return
    const key = getLinkageRowId(item)
    const next = { ...editedAmountsRef.current }
    if (amount === getBaselineAmount(item)) delete next[key]
    else next[key] = amount
    editedAmountsRef.current = next
    startTransition(() => setEditedAmounts(next))
  }
  const [tipoPago, setTipoPago] = useState("")
  const [dataTraspaso, setDataTraspaso] = useState({})
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({})
  const [currentSelectedRealIds, setCurrentSelectedRealIds] = useState([])
  const [showConfirmPopup, setShowConfirmPopup] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')
  const [modalData, setModalData] = useState({
    razonSocial: '',
    rut: '',
    fecha: '',
    descripcion: '',
    folio: '',
    monto: 0,
    tipoObligacion: 'pago-anterior'
  })

  useEffect(() => {
    if (Array.isArray(data?.linkage) && data.linkage.length > 0) {
      const initialIds = data.linkage.map(getLinkageRowId).filter(id => id != null);
      setInitialSelectedIds(initialIds);
      setCurrentSelectedIds(initialIds);

      const initChecked = {};
      initialIds.forEach(id => (initChecked[id] = true));
      setSelectedCheckboxes(initChecked);
      setSelectedRowsData(data.linkage);
    }
  }, [data?.linkage]);

    const handleCheckboxToggle = (item, checked) => {
      const rowId = getLinkageRowId(item)
      const realId = item.idPrincipal ?? item.id 

      setSelectedCheckboxes(prev => ({
        ...prev,
        [rowId]: checked
      }))
      setCurrentSelectedIds(prev =>
        checked ? [...new Set([...prev, rowId])] : prev.filter(id => id !== rowId)
      )
      setSelectedRowsData(prev =>
        checked
          ? prev.some(r => getLinkageRowId(r) === rowId) ? prev : [...prev, item]
          : prev.filter(r => getLinkageRowId(r) !== rowId)
      )
      setCurrentSelectedRealIds(prev =>
        checked
          ? [...new Set([...prev, realId])]
          : prev.filter(id => id !== realId)
      )
    }

  useEffect(() => {
    setSelectedCheckboxes(prev => {
      const updated = { ...prev };
      let changed = false
      selectedRowsData.forEach(item => {
        const rowId = getLinkageRowId(item)
        if (updated[rowId] === undefined) {
          updated[rowId] = currentSelectedIds.includes(rowId);
          changed = true
        }
      });
      return changed ? updated : prev;
    });
  }, [selectedRowsData, currentSelectedIds]);

  const handleClose = () => {
    if (creatingLinkage) return
    setOpen(false)
    setSwitchGetData(true)
  }

  const functionGetDataLibroContable = async (silent = false) => {
    try {
      if (!silent) setLoading(true)
      const response = await bancoAPI.getDataLibros(currentBusiness?.id, libroId)
      if (!silent) setData(normalizeConciliationPayload(response.data))
      return response?.data
    } catch (error) {
      console.error(error)
      return null
    } finally {
      if (!silent) setLoading(false)
    }
  }

  const functionDatoBancario = async () => {
    if (!data?.fecha) return

    const fecha = new Date(data.fecha)
    const yearFilter = fecha.getFullYear()
    const monthParam = String(fecha.getMonth() + 1).padStart(2, "0")

    try {
      setLoading(true)

      const limit = 10000
      const productId = 0

      const response = await bancoAPI.getTransactionsSummary(
        productId,
        currentBusiness.id,
        limit,
        yearFilter,
        monthParam
      )

      // Normalizamos fecha y monto para comparar
      const fechaData = new Date(data.fecha).toISOString().split("T")[0] // "2025-08-29"
      const montoData = Number(data.montoTotal)

      const filtrados = Array.isArray(response)
        ? response.filter(item => {
            const fechaItem = new Date(item.fecha).toISOString().split("T")[0]
            const montoAbono = Number(item.montoAbono)
            const montoCargo = Number(item.montoCargo)

            return (
              item.tipoMovimiento === "Traspaso entre cuentas" && // solo traspasos
              fechaItem === fechaData &&
              (montoAbono === montoData || montoCargo === montoData)
            )
          })
        : []
      setDataTraspaso(filtrados) // si no hay coincidencias => []
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  // Llamas primero a obtener el libro contable
  useEffect(() => {
    if (open) {
      functionGetDataLibroContable()
    }
  }, [reloadData])

  // Y cuando data cambia y ya tiene fecha, llamas a functionDatoBancario
  useEffect(() => {
    if (data?.fecha) {
      functionDatoBancario()
    }
  }, [data])

  const formatFecha = (fecha) => {
    if (!fecha) return '';
    const [anio, mes, dia] = fecha.split('-');
    return `${anio}-${mes}-${dia}`;
  };
  
  const handleGestion = async () => {
    try {
      const payload = {
        fecha: formatFecha(modalData.fecha),
        transaccionId: libroId,
        monto: modalData.monto,
        razonSocial: modalData.razonSocial,
        rut: modalData.rut,
        nombreComprobante: modalData.descripcion,
        extra: {
          descripcion: modalData.descripcion,
          folio: modalData.folio
        }
      };

      if (data?.origenTabla === 6) {
        await businessAPI.postAnterior(currentBusiness.id, payload, 'cobro-anterior');
      } else if (data?.origenTabla === 7) {
        const obligationModel = [
          'pago-anterior',
          'pago-anterior-previred',
          'pago-anterior-remuneraciones'
        ].includes(modalData.tipoObligacion)
          ? modalData.tipoObligacion
          : 'pago-anterior'
        await businessAPI.postAnterior(currentBusiness.id, payload, obligationModel);
      }

    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (createdSelection, adjustment) => {
    const automatic = Array.isArray(createdSelection)
    if (creatingLinkage && !automatic) return
    const rowsToSave = automatic ? createdSelection : selectedRowsData
    const selectedIdsToSave = automatic ? rowsToSave.map(getLinkageRowId) : currentSelectedIds
    const realIdsToSave = automatic ? rowsToSave.map(item => item.idPrincipal ?? item.id).filter(id => id != null) : currentSelectedRealIds
  try {
    const idMap = new Map();
    (data.linkage ?? []).forEach(item => {
      idMap.set(getLinkageRowId(item), item.idPrincipal ?? item.id);
    });

    (rowsToSave ?? []).forEach(item => {
      idMap.set(getLinkageRowId(item), item.idPrincipal ?? item.id);
    });

    const existingIds = new Set((data.linkage ?? [])
      .map(item => Number(item.idPrincipal ?? item.id)))
    const idsParaConciliar = [...new Set([
      ...realIdsToSave,
      ...rowsToSave.filter(item => !item.customRow).map(item => item.idPrincipal ?? item.id)
    ].map(Number))].filter(id => !existingIds.has(id));

    const idsParaDesvincular = initialSelectedIds
      .filter(id => !selectedIdsToSave.includes(id))
      .map(id => idMap.get(id))
      .filter(id => id != null && String(id).trim() !== '')
      .map(Number)
      .filter(Number.isFinite);

    const payload = buildBankConciliationPayload(idsParaConciliar, rowsToSave, automatic ? {} : editedAmountsRef.current)
    const finalIdsParaDesvincular = idsParaDesvincular;

    // --- 1️ Desvincular si corresponde
    if (finalIdsParaDesvincular.length > 0) {
      await organizationAPI.postDesvincular(
        { businessId: Number(currentBusiness.id), idLibro: Number(libroId) },
        { ids: finalIdsParaDesvincular }
      );
    }

    // --- 2️ Vincular si corresponde
    if (payload.ids.length > 0 || payload.montoId?.length > 0) {
      await organizationAPI.postListaVincular(
        applyConciliationAdjustment({ businessId: Number(currentBusiness.id), idLibro: Number(libroId) }, adjustment),
        payload
      );
    }

    // --- 3️ Gestión especial de "Caja"
    // --- 3️ Gestión especial de "Caja"
      const hasCajaSeleccionada = rowsToSave.some(r => r.customRow);

      if (hasCajaSeleccionada) {
        await handleGestion();
      } else {
        await organizationAPI.postDesvincular(
          { businessId: Number(currentBusiness.id), idLibro: Number(libroId) },
          { ids: ["custom-caja-principal"] } // o el ID real
        );
      }

    const refreshMovementOverride = async () => {
      const refreshed = await functionGetDataLibroContable(automatic)
      if (!refreshed) return

      // Si no hay linkage, no existe summary-movement
      if (!Array.isArray(refreshed.linkage) || refreshed.linkage.length === 0) {
        setMovementOverride(null)
        return
      }

      const movementId = Number(getLinkageRowId(refreshed.linkage[0]))
      if (!movementId) return

      try {
        const response = await businessAPI.getSummaryMovementById(
          currentBusiness.id,
          movementId
        )
        setMovementOverride(response?.data ?? response)
      } catch (e) {
        console.warn('[Bancos] Movimiento ya no existe, se omite refresh puntual')
      }
    }

    // --- 4️ Actualizar vista
    await refreshMovementOverride()
    if (!automatic) {
      setSwitchGetData(true);
      setOpen(false);
    }
  } catch (error) {
    console.error(" Error en la conciliación:", error);
    if (automatic) throw error;
  }
};


  useEffect(() => {
    const dataDetalleSelect = async () => {
      try {
        let params = {
          businessId: currentBusiness.id,
          limit: 100,
          type: data.categoriaTipoMovimiento === 'abono' ? 'boleta' : 'factura',
          state: 'por-pagar',
          order: 'ASC'
        }

        const responseCuentas = await businessAPI.getPorCobrarCobradas(params)
        // setSwitchDate(false)
        setDataCuentas(responseCuentas.data.data)
      } catch (error) {
        console.error(error)
      } finally {
        // ui.setLoader({ visible: false, text: '' })
      }
    }
    dataDetalleSelect()
  }, [data])

  //const handleOpen = () => setOpenModalCreate(true)

  useEffect(() => {
    if (data.linkage) {
      setReload(prev => !prev) // Forzar un re-render
    }
  }, [data])

  submitRef.current = handleSubmit
  const montoFilter = data.montoTotal
  const montoTotalAbsoluto = Math.abs(Number(data?.montoTotal ?? 0))

  const totalAplicado = useMemo(() => {
    return selectedRowsData.reduce((acc, item) => {
      return acc + getSelectedAmount(item)
    }, 0)
  }, [selectedRowsData, data?.linkage, editedAmounts])

  const saldoPorCobrar = useMemo(() => {
    const total = Math.abs(Number(data?.montoTotal ?? 0))
    return total - totalAplicado
  }, [data?.montoTotal, totalAplicado])

  const allocation = useMemo(() => allocateConciliationMovements(
    montoTotalAbsoluto,
    selectedRowsData.map(item => ({ available: getSelectedAmount(item) }))
  ), [montoTotalAbsoluto, selectedRowsData, data?.linkage, editedAmounts])

    const obtenerAbreviatura = nombre => { return translations.documentosContables[nombre] || nombre }

  return (
    <>
    <BankLinkageProgress status={creationStatus} error={creationError} onDismiss={() => { setCreationError(''); handleCreationCompleted() }} />
    <ResizableModal open={open && !creationError} onClose={handleClose} size="large"
    footer={
      <>
        <Button
            onClick={handleClose}
            className='text-[10px] bg-primary text-white rounded-full'
            title='Cerrar'
            disabled={creatingLinkage}
          />
          <Button
            className='text-[10px] bg-accent2 text-white rounded-full'
            title='Guardar Conciliación'
            disabled={creatingLinkage}
            onClick={() => {
              if (selectedRowsData.length === 0) {
                handleSubmit()
                return
              }
             const montoPorSaldar = montoTotalAbsoluto - selectedRowsData.reduce((sum, item) =>
               sum + (editedAmountsRef.current[getLinkageRowId(item)] ?? getBaselineAmount(item)), 0)
              if (montoPorSaldar > 0) {
                setPopupMessage( 'El monto conciliado es inferior al saldo pendiente.'  )
                setShowConfirmPopup(true)
              } else if (montoPorSaldar < 0) {
                setPopupMessage( 'El monto conciliado supera el saldo pendiente.' )
                setShowConfirmPopup(true)
              } else {
                handleSubmit()
              }
            }}
          />
        </>
        }
        >
            <>
            {loading && !creatingLinkage ?  (
            <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
              <Lottie animationData={LoaderMain} loop autoplay style={{ width: 100, height: 100 }} />
            </Box>
            ) : (
            <>
            <div className='flex w-full h-full gap-4'>
              {/* LISTA IZQUIERDA */}
              <div className="flex-1 h-full w-[65%]">
                <FiltrosLista 
               libroId={libroId} 
               montoFilter={montoFilter} 
               dataLinkage={data.linkage} 
               setReloadData={setReloadData} 
               reloadData={reloadData} 
               dataModal={data}
               onInitialSelectedIds={setInitialSelectedIds}
               onCurrentSelectedIdsChange={setCurrentSelectedIds}
               setSwitchGetData={setSwitchGetData}
               onCurrentData={handleCurrentData}
               tipoPago={tipoPago}
               setTipoPago={setTipoPago}
               dataTraspaso={dataTraspaso}
               selectedCheckboxes={selectedCheckboxes}
               setSelectedCheckboxes={setSelectedCheckboxes}
               onCurrentRealIdsChange={setCurrentSelectedRealIds}
               modalData={modalData}
               onCreationStatusChange={setCreationStatus}
               onCreationError={setCreationError}
               onCreationCompleted={handleCreationCompleted}
               onConciliateCreated={handleConciliateCreated}
               setModalData={setModalData}
               />
                </div>
                <div className='flex flex-col w-[35%] h-full font-sans font-medium'>
                  <div className='flex-1 flex flex-col bg-white rounded-3xl shadow-lg p-2 text-[11px] overflow-auto'>
                    <div className="mb-6">
                      {/* FILA 1: Banco y fecha */}
                      <div className='flex justify-between items-start mb-1'>
                        <div className='flex gap-2'>
                          <img className='w-5 h-5 mt-1' src={bankIcons[data.nombreBanco] || imgDefaultBank} alt='' />
                          <div className='flex flex-col'>
                            <p className='text-[12px] font-bold uppercase leading-tight'>{data.nombreBanco}</p>
                            <p className="text-[12px] uppercase leading-tight">{getConciliationAccountDisplayNumber(data, data.numeroCuentaBanco)}</p>
                          
                        <div className='flex items-center gap-1 text-[13px] text-gray-600 leading-tight'>
                          {formatDate(data.fecha)}
                        </div>
                        </div>
                        </div>

                      {/* Derecha: Estado y monto */}
                        <div className='flex flex-col items-end text-right text-[12px] min-w-[110px] whitespace-nowrap'>
                          <p className={data.status === 'PENDIENTE' ? 'text-accent3 font-bold' : 'text-accent2 font-bold'}>
                            {data.status}
                          </p>
                          <p className='text-[13px] font-semibold leading-tight'>{formatCurrency(montoTotalAbsoluto)}</p>
                          <ForeignAmountDetail movement={data} amount={montoTotalAbsoluto} />
                        </div>
                      </div>

                       {/* Descripción/glosa */}
                      <div className='flex justify-between items-start mt-5 text-[12px] w-full border-b pb-1'>
                        <p className="font-semibold leading-tight break-words whitespace-normal">
                          Glosa: {data.descripcion}
                        </p>

                        <div className="flex flex-col items-end min-w-[100px] text-right">
                          <p className='uppercase font-semibold text-gray-600 leading-tight'>
                            {data.categoriaTipoMovimiento}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className='flex-1 overflow-auto font-sans font-medium'>
                      {selectedRowsData.length > 0 ? (
                        selectedRowsData.map((item, idx) => {
                          const adjustmentMovement = getAdjustmentMovement(item)
                          const isChecked = !!selectedCheckboxes[getLinkageRowId(item)]
                            const montoElegido = getSelectedAmount(item)
                            const formatText = (text = '') => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()

                              const getDisplayName = (item) => {
                                const currentYear = new Date().getFullYear()
                                const fechaPagoYear = item?.fechaPago ? new Date(item.fechaPago).getFullYear() : null
                                const fechaYear = item?.fecha ? new Date(item.fecha).getFullYear() : null
                                const sourceText = isF29Movement(item)
                                  ? [item?.glosa, item?.descripcion].filter(Boolean).join(' ')
                                  : item?.glosa || item?.descripcion || ''
                                const f29Match = sourceText.match(/f29\s*-\s*(.+)$/i)
                                const monthMatch = sourceText.match(/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|setiembre|octubre|noviembre|diciembre)\b/i)
                                const getLabelWithMonth = (label) =>
                                  monthMatch?.[1]
                                    ? `${formatText(monthMatch[1])} - ${label}`
                                    : label
                                const shouldUseRazonSocial =
                                  !!item?.razonSocial &&
                                  Number.isFinite(fechaPagoYear) &&
                                  Number.isFinite(fechaYear) &&
                                  fechaPagoYear === currentYear &&
                                  fechaYear === currentYear - 1

                                if (isF29Movement(item)) {
                                  return f29Match?.[1]
                                    ? `F29 - ${f29Match[1].trim().toLowerCase()}`
                                    : 'F29'
                                }
                                if (item.origenTabla === 30) return getLabelWithMonth('PreviRed')
                                if (item.origenTabla === 29) return getLabelWithMonth('Monto Líquido')
                                if (shouldUseRazonSocial) {
                                  return item.razonSocial
                                }
                                if (isVinculacionRow(item)) {
                                  return item.nombreCuenta || '<Sin Nombre>'
                                }

                                if (item.razonSocial) {
                                  return formatText(item.razonSocial)
                                }

                                return item.descripcion || item.glosa || '<Sin Razón Social>'
                              }
                          return (
                            <div
                              key={getLinkageRowId(item)}
                              className='flex justify-between items-center text-gray-700 py-1 border-b last:border-0'
                            >
                              {/* LADO IZQUIERDO */}
                              <div className='flex flex-1 min-w-0 flex-wrap items-center gap-2 pr-2 break-words'>
                                <input
                                  type='checkbox'
                                  className='rounded'
                                  checked={isChecked}
                                  onChange={e => handleCheckboxToggle(item, e.target.checked)}
                                />
                                {isBankConciliationMovement(item) ? (
                                    <img src={bankIcons[item.nombreCuentaBanco] || imgDefaultBank} alt={item.nombreCuentaBanco || 'Banco'} className='max-h-8 max-w-8' />
                                  ) : isVinculacionRow(item) ? (
                                    <VinculacionIcon item={item} />
                                  ) : ([item.nombreOrigen, item.origen]
                                  .some(value => value?.trim().toLowerCase() === 'sii') ||
                                  isF29Movement(item)) ? (
                                    <img src={isologo_SII} className='max-h-5 max-w-5' />
                                  ) : (item.razonSocial?.trim().toLowerCase() === 'previred' || item.origenTabla === 30) ? (
                                    <img src={iconPrevired} className='max-h-10 max-w-10' />
                                  ) : (
                                    <img src={iconVinculos} className='max-h-10 max-w-10' />
                                  )}
                                <div className='flex flex-col leading-tight'>
                                  <span>{obtenerAbreviatura(item.nombreFolio || item.nombreCuentaBanco)}</span>
                                  <span>{getConciliationAccountDisplayNumber(item, item.numeroFolio || item.numeroCuentaBanco)}</span>
                                </div>
                                <span>{getFolioCreditoLabel(item) || getDisplayName(item)}</span>
                                <span>{formatDate(getMovementRelationDate(item, data?.linkage ?? []))}</span>
                              </div>
                              
                              <div className='flex flex-col shrink-0 text-right min-w-[120px] gap-1'>
                                {getConciliationAdjustmentDisplay(adjustmentMovement) ? <ConciliationAdjustmentAmount movement={adjustmentMovement} documentTotal={montoTotalAbsoluto} formatCurrency={formatCurrency} /> : <>
                                <span className='text-gray-400'>Disponible Asignado</span>
                                {item.customRow ? <span className='text-right w-20'>{formatCurrency(montoElegido)}</span> : (
                                  <AssignedAmountInput
                                    aria-label={`Monto asignado ${getLinkageRowId(item)}`}
                                    className='modal-control border rounded-full text-xs text-right px-2 py-1 w-28 self-end font-sans text-gray-900 bg-white'
                                    value={montoElegido}
                                    max={getVinculacionAvailableAmount(item)}
                                    disabled={creatingLinkage}
                                    onCommit={value => handleAmountChange(item, value)}
                                  />
                                )}
                                </>}
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        // Esto se muestra cuando no hay nada seleccionado
                        (data?.linkage?.length ?? 0) > 0 ? null : (
                          <div className='text-gray-400 italic text-center py-4'>
                            {/* opcional: “Sin datos seleccionados” */}
                          </div>
                        )
                      )}
                    </div>
                      <div className='flex justify-between border-t text-sm font-semibold mt-2 pt-1 shrink-0'>
                        <span>Monto Saldado</span>
                        <span>{formatCurrency(allocation.assigned)}</span>
                      </div>

                      <div className='flex justify-between mt-1 text-sm font-semibold text-accent2 shrink-0'>
                        <span>Diferencia</span>
                        <span>{formatCurrency(saldoPorCobrar)}</span>
                      </div>
                  </div>
              </div>
          </div>
            </>
          )}
      </>
      <ConfirmConciliationModal
        difference={saldoPorCobrar}
        onGenerateAdjustment={adjustment => {
          setShowConfirmPopup(false)
          handleSubmit(undefined, adjustment)
        }}
        open={showConfirmPopup}
        message={popupMessage}
        onClose={() => setShowConfirmPopup(false)}
        actions={[
          { id: 'back', title: 'Volver', onClick: () => setShowConfirmPopup(false) },
          {
            id: 'save',
            title: 'Guardar',
            className: 'rounded-full bg-accent2 px-5 text-sm text-white',
            onClick: () => {
              setShowConfirmPopup(false)
              handleSubmit()
            }
          }
        ]}
      />
    </ResizableModal>
    </>
  )
}

export default ModalDialogMotionEditForm
